<template>
    <b-dropdown
        v-if="info || example || infoUrl"
        append-to-body
        position="is-bottom-right"
        aria-role="menu"
        class="info-popover"
    >
        <template #trigger>
            <b-icon
                icon="information-outline"
                size="is-small"
                class="info-trigger"
            />
        </template>
        <b-dropdown-item custom :focusable="false" class="info-content">
            <p v-if="info" class="info-text">{{ info }}</p>
            <p v-if="example" class="info-text">
                <strong>Beispiel:</strong> {{ example }}
            </p>
            <a
                v-if="infoUrl"
                :href="infoUrl"
                target="tagebuch-anleitung"
                rel="noopener"
                class="info-link"
            >
                Anleitung öffnen
            </a>
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>

export default {
    name: "InfoPopover",
    props: ["info", "example", "infoUrl"],
};
</script>

<style lang="scss" scoped>
.info-popover {
    vertical-align: middle;
}

.info-trigger {
    cursor: pointer;
    color: #7a7a7a;
    position: relative;
    top: -0.1em;
}

.info-content {
    max-width: 320px;
    white-space: normal;
    font-size: 0.85rem;
    font-weight: normal;
}

.info-text {
    margin-bottom: 0.5em;
}

.info-link {
    font-weight: bold;
}
</style>
